import { AbacoWebModule, RouterReadyEvent } from "@abaco/web-common/src/app";
import globals from "./globals";
import DemoColdirettiPopUpApi from "./api/DemoColdirettiPopUpApi";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import DemoColdirettiPopUpModuleVuexModule from "./state";
import { ApplicationReadyEvent } from "@abaco/web-common/src/app/Application";
import SSOModule from "@abaco/sso-web-module/src/abaco-module";

export const MODULE_ID = "demo_coldiretti_popup_module";

export default class DemoColdirettiPopUpModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private apiCreated = false;
    private dmCldrttApi!: DemoColdirettiPopUpApi;
    private http!: HTTPClient;
    private modalDemoAlreadyShown = false;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly vuexModule = new DemoColdirettiPopUpModuleVuexModule();
    private ssoModule!: SSOModule;

    async beforeEnterAnyRoutes(http: HTTPClient) {
        this.initApi();
    }

    onApplicationReady(event: ApplicationReadyEvent) {
        this.ssoModule = event.modules.find(m => m.id === SSOModule.MODULE_ID) as SSOModule;
        if(!this.ssoModule) {
            throw new Error("SSOModule not found");
        }
    }

    onRouterReady(event: RouterReadyEvent) {
        this.http = event.http;
        
        event.router.beforeEach(async (to, from, next) => {
            try {
                await this.initApi();
                if(!this.ssoModule.vuexModule.user){
                    this.modalDemoAlreadyShown = false;
                    next();
                    return;
                }
                if(!this.modalDemoAlreadyShown){
                    this.vuexModule.hasAlreadySubmittedSubscription = await this.demoColdirettiPopUpApi.getSubscriptionStatus();
                    this.modalDemoAlreadyShown = true;
                    this.vuexModule.showDemoModal = !this.vuexModule.hasAlreadySubmittedSubscription
                }
            } catch(error){
                console.error(error)
            }
            next();
        })
    }

    get demoColdirettiPopUpApi() {
        return this.dmCldrttApi;
    }

    private async initApi(){
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const DemoColdirettiPopUpApi = (
            await import("./api/DemoColdirettiPopUpApi")
        ).default;
        this.dmCldrttApi = new DemoColdirettiPopUpApi(this.http);
    }
}
